import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppConfigServiceService } from './app-config-service.service';
import { HelpersService } from './shared/helpers.service';
import { MapListModel } from '../models/MapListModel';
import { Observable } from 'rxjs';
import { MapListSkladisc } from '../models/map-list-skladisc';



@Injectable({
  providedIn: 'root'
})
export class WarehouseAppService {

  private baseUrl = 'https://portal.bilumina.com/develWebService/rest/pos/get_warehouses_list';

  public curHostname;

  constructor(private http: HttpClient, private appConfigService: AppConfigServiceService, private helpersService: HelpersService) {
    this.helpersService.currentHostname.subscribe( data => {
      this.curHostname = data;
    });
   }

  //  async requestCameraPermission(): Promise<boolean> {
  //   try {
  //     const stream = await navigator.mediaDevices.getUserMedia({ video: true });
  //     stream.getTracks().forEach(track => track.stop());
  //     return true;
  //   } catch (error) {
  //     console.error('Camera permission denied', error);
  //     return false;
  //   }
  // }

  getWarehousesList(username): Observable<MapListSkladisc> {
    let params = new HttpParams();
    params = params.append("username", username);
    params = params.append("noPrefix", "1");
    
    const fullUrl = this.baseUrl + '?' + params.toString();

    console.log("Full URL:", fullUrl);
    
    return this.http.get<MapListSkladisc>(this.baseUrl, { params });
  }

  mobileSearchScan(scan) {
    let params = new HttpParams();

    params = params.append('sessionUser', 'LUMINA');
    if (scan) {
      params = params.append('scan', scan);
    }    

    const fullUrl = this.curHostname + this.appConfigService.mobile + 'mobileSearchScan';

    return this.http.post<any>(fullUrl, params);
  }

  mobileSearchScanDocuments(dwarId) {
    let params = new HttpParams();

    params = params.append('sessionUser', 'LUMINA');
    if (dwarId) {
      params = params.append('dwarId', dwarId);
    }

    const fullUrl = this.curHostname + this.appConfigService.mobile + 'mobileSearchScanDocuments';

    const headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded');

    return this.http.post<any>(fullUrl, params, { headers });
  }

  // getWarehousesListTest(): Observable<MapListModel> {
  //   const fullUrl = "https://www.bilumina.com/develWebService/rest/pos/get_warehouses_list?username=NET@7C7BD248_13F7_46C3_B840_639C37787A0A&noPrefix=1";
  
  //   console.log("Full URL:", fullUrl);
    
  //   return this.http.get<MapListModel>(fullUrl);
  // }

}
